import {
    Flex,
    Text,
    VStack,
    HStack,
    Box,
    SimpleGrid,
    Container,
    IconButton,
    useBreakpointValue
} from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import HomeRowLargeCard from '../../common/HomeRowLargeCard'
import ProductCard from '../../common/ProductCard'
import { FaArrowLeftLong, FaArrowRightLong, FaLeftLong, FaRightLong } from 'react-icons/fa6'
import OutlinedButton from '../../common/OutlinedButton'
import Carousel from "react-multi-carousel";
import ProductCarouselCardMobile from '../../common/ProductCarouselCardMobile'
import { useCollections } from '../../../providers/CollectionsProvider'
import CustomHomeCarousel from '../../CustomHomeCarousel'
import { useProduct } from '../../../providers/ProductProvider'
import { useHomeCustomization } from '../../../providers/HomeCustomizationProvider'
import { Link } from 'react-router-dom'

export default function Home() {

    const { loading: collectionsLoading, collectionsForHomePage, getCollectionProducts } = useCollections();
    const { products } = useProduct();

    const { collections } = useCollections();

    const { homeSliderProducts, celebrityClosetProducts, focusedCollection } = useHomeCustomization();

    const [focusedCollectionProducts, setFocusedCollectionProducts] = useState([]);
    const [homeSliderProductsData, setHomeSliderProductsData] = useState([]);
    const [celebrityClosetProductsData, setCelebrityClosetProductsData] = useState([]);

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 1900 },
            items: 6,
            slidesToSlide: 1
        },
        desktop: {
            breakpoint: { max: 1900, min: 1024 },
            items: 5,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3,
            slidesToSlide: 3,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 2,
            // spacing: 10
            slidesToSlide: 2,
        }
    };


    const isThisMobile = useBreakpointValue(
        {
            base: true,
            md: true,
            lg: false,
            xl: false,
        },
    )

    const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
        const { carouselState: { currentSlide } } = rest;

        return <Box display='flex' justifyContent='space-between' w='100%' position='absolute'>
            <IconButton variant='ghost' ms='-30px' icon={<FaLeftLong />} onClick={() => previous()} />
            <IconButton variant='ghost' icon={<FaRightLong />} onClick={() => next()} />
        </Box>
        // return (
        //     <div className="carousel-button-group">
        //         <Button bg='red' className={currentSlide === 0 ? 'disable' : ''} onClick={() => previous()} />
        //         <Button onClick={() => next()} />
        //         {/* <Button onClick={() => goToSlide(currentSlide + 1)}> Go to any slide </Button> */}
        //     </div>
        // );
    };

    var carousel = useRef(null);
    var carouselCelebrityCloset = useRef(null);

    async function getFocusedCollectionProducts() {
        if (focusedCollection.length > 0) {
            const products = await getCollectionProducts(focusedCollection[0].collection_id);
            // if more than 3 , only set 3 
            if (products.length > 3) {
                products = products.slice(0, 3);
            }
            setFocusedCollectionProducts(products);
        }
    }

    useEffect(() => {
        getFocusedCollectionProducts();
    }, [focusedCollection]);

    useEffect(() => {

        let tempHomeSlider = [];
        let tempCelebrityCloset = [];

        for (var p of products) {
            if (homeSliderProducts.find(sliderProduct => sliderProduct.product_id === p.products.id)) {
                tempHomeSlider.push(p);
            }
            if (celebrityClosetProducts.find(closetProduct => closetProduct.product_id === p.products.id)) {
                tempCelebrityCloset.push(p);
            }
        }

        setHomeSliderProductsData(tempHomeSlider);
        setCelebrityClosetProductsData(tempCelebrityCloset);


    }, [products]);

    return (
        <Flex
            flexDirection={'column'}
            justifyContent={'space-between'} alignItems={'center'}
            bg={'#FFFFFF'}
        >
            <CustomHomeCarousel />

            <Container maxW='9xl' py='6'>

                <VStack w='100%' spacing='4'>

                    {/* Mobile Carousel Products  */}
                    {isThisMobile &&
                        <Box
                            w='100%'
                            // bg='red'
                            h='320px'
                        >
                            <Carousel responsive={responsive} arrows={false}>
                                {
                                    homeSliderProductsData.map((item, index) => {
                                        return <ProductCarouselCardMobile item={item} key={index} />
                                    })
                                }
                            </Carousel>
                        </Box>
                    }


                    <Box w='100%'
                        display={['none', 'none', 'none', 'flex']}
                        justifyContent={'center'}
                        alignItems={'center'}
                        h='100%'
                    // bg='red'
                    >
                        <IconButton
                            variant='ghost'
                            bg='transparent'
                            mx='2%'
                            _hover={{
                                bg: 'white'
                            }}
                            onClick={() => {
                                carousel.previous();
                            }}
                            icon={<FaArrowLeftLong size='24' />}
                        />
                        <Box
                            w='75%'
                            overflow='hidden'
                        >
                            <Carousel
                                // additionalTransfrom={-20 * 5}
                                ref={el => (carousel = el)}

                                arrows={false}
                                swipeable={true}
                                draggable={true}
                                responsive={responsive}
                            // renderButtonGroupOutsideside={true}
                            // customButtonGroup={<ButtonGroup />}
                            >
                                {
                                    homeSliderProductsData.map((item, index) => {
                                        return <ProductCard item={item} key={index} />
                                    })
                                }
                            </Carousel>
                        </Box>

                        <IconButton
                            mx='2%'
                            variant='ghost'
                            bg='transparent'
                            _hover={{
                                bg: 'white'
                            }}
                            onClick={() => {
                                carousel.next();
                            }}
                            icon={<FaArrowRightLong size='24' />}
                        />
                    </Box>



                    {!collectionsLoading ?
                        <SimpleGrid columns={[1, 1, 1, 1, 2]} w='100%' spacing={4} px={['0', '0', '40px', '12.5%']}>
                            {
                                collectionsForHomePage.map((item, index) => {
                                    return <HomeRowLargeCard item={item} key={index} />
                                })
                            }
                        </SimpleGrid>
                        : <></>}

                    {focusedCollection.length > 0 &&
                        <HStack
                            // bg='red'
                            display={['none', 'none', 'none', 'flex']}
                            w='75%'
                            alignItems='flex-start'
                            justifyContent='start'
                            my='8'
                        >

                            <HStack
                                width='100%'
                                spacing='12'
                                alignItems='start'
                            >

                                <VStack minW='400px' spacing='4' h='100%' alignItems='start' justifyContent='start'>
                                    {(collections && focusedCollection && collections.length > 0 && focusedCollection.length > 0) &&
                                        <>
                                            <Text fontSize='3xl'>{collections.find(collection => collection.id === focusedCollection[0].collection_id).name}</Text>
                                            <Text fontSize='md'>{focusedCollection[0].content} </Text>
                                        </>
                                    }

                                </VStack>

                                {focusedCollectionProducts && focusedCollectionProducts.length != 0 &&
                                    <>
                                        {focusedCollectionProducts.map((item, index) => {
                                            return <ProductCard item={item} key={index} />
                                        })}
                                    </>
                                }
                            </HStack>
                        </HStack>
                    }


                    {/* Mobile Screen  */}

                    {focusedCollection.length > 0 &&
                        <VStack display={['flex', 'flex', 'flex', 'none']} mt='4' spacing='4' h='100%' alignItems='start' justifyContent='start'>
                            {(collections && focusedCollection && collections.length > 0) &&
                                <>
                                    <Text fontSize='3xl'>{collections.find(collection => collection.id === focusedCollection[0].collection_id).name}</Text>
                                    <Text fontSize='md'>{focusedCollection[0].content} </Text>
                                </>
                            }

                        </VStack>
                    }

                    {/* Mobile Carousel Products  */}
                    {isThisMobile &&
                        <Box
                            w='100%'
                            // bg='red'
                            h='320px'
                        >
                            <Carousel responsive={responsive} arrows={false}>
                                {
                                    products.map((item, index) => {
                                        return <ProductCarouselCardMobile item={item} key={index} />
                                    })
                                }
                            </Carousel>
                        </Box>
                    }

                    {focusedCollection.length > 0 &&
                        <OutlinedButton as={Link} to={`/collections/${focusedCollection[0].collection_id}`}>
                            Explore More
                        </OutlinedButton>
                    }


                    <Text textAlign={'center'} fontSize={'xx-large'}
                        color={'#966754'}
                        my='6'
                    >
                        CELEBRITY CLOSET
                    </Text>


                    {/* Mobile Version  */}

                    {/* Mobile Carousel Products  */}
                    {isThisMobile &&
                        <Box
                            w='100%'
                            // bg='red'
                            h='320px'
                        >
                            <Carousel responsive={responsive} arrows={false}>
                                {
                                    celebrityClosetProductsData.map((item, index) => {
                                        return <ProductCarouselCardMobile item={item} key={index} />
                                    })
                                }
                            </Carousel>
                        </Box>
                    }


                    <Box w='100%'
                        justifyContent={'center'}
                        alignItems={'center'}
                        display={['none', 'none', 'none', 'flex']}
                        h='100%'
                    // bg='red'
                    >
                        <IconButton
                            variant='ghost'
                            bg='transparent'
                            mx='2%'
                            _hover={{
                                bg: 'white'
                            }}
                            onClick={() => {
                                carouselCelebrityCloset.previous();
                            }}
                            icon={<FaArrowLeftLong size='24' />}
                        />
                        <Box
                            w='75%'
                            overflow='hidden'
                        >
                            <Carousel
                                // additionalTransfrom={-20 * 5}
                                ref={el => (carouselCelebrityCloset = el)}

                                arrows={false}
                                swipeable={true}
                                draggable={true}
                                responsive={responsive}
                            // renderButtonGroupOutsideside={true}
                            // customButtonGroup={<ButtonGroup />}
                            >
                                {
                                    celebrityClosetProductsData.map((item, index) => {
                                        return <ProductCard item={item} key={index} />
                                    })
                                }
                            </Carousel>
                        </Box>

                        <IconButton
                            mx='2%'
                            variant='ghost'
                            bg='transparent'
                            _hover={{
                                bg: 'white'
                            }}
                            onClick={() => {
                                carouselCelebrityCloset.next();
                            }}
                            icon={<FaArrowRightLong size='24' />}
                        />
                    </Box>

                </VStack>

            </Container>
        </Flex>
    )
}
